export class Sucursal{
    public constructor(
        public id:String = "",
        public nombre:String = "",
        public direccion:String = "",
        public celular:String = "",
        public telefono:String = "",
        public correo:String = "",
        public establecimiento:String = "",
        public empresa_id:String = "",
        public usuario_id:String = null
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/sucursal.ts